import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "q-px-sm q-pt-xs" }
const _hoisted_2 = { class: "row items-center no-wrap" }
const _hoisted_3 = {
  class: "col row q-gutter-xs q-py-xs",
  style: {"flex-wrap":"wrap"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
          return (_openBlock(), _createBlock(_component_q_chip, {
            key: `category-${category.id}`,
            removable: "",
            dense: "",
            color: "primary",
            "text-color": "white",
            size: "sm",
            onRemove: ($event: any) => (_ctx.$emit('remove-category', category.id))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(category.name), 1)
            ]),
            _: 2
          }, 1032, ["onRemove"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label) => {
          return (_openBlock(), _createBlock(_component_q_chip, {
            key: `label-${label.id}`,
            removable: "",
            dense: "",
            color: "primary",
            "text-color": "white",
            size: "sm",
            onRemove: ($event: any) => (_ctx.$emit('remove', label))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(label.name), 1)
            ]),
            _: 2
          }, 1032, ["onRemove"]))
        }), 128))
      ]),
      _createVNode(_component_q_btn, {
        size: "sm",
        color: "grey",
        label: "Clear",
        icon: "fa fa-times",
        flat: "",
        dense: "",
        "no-caps": "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear')))
      })
    ]),
    _createVNode(_component_q_separator)
  ]))
}